import { formatMillisecondsToHumanReadable } from './formatMillisecondsToHumanReadable'
import { getMetricFormatter } from './getMetricFormatter'

export function formatMetric(
  value: number,
  unit: 'percent' | 'second' | 'compact-unit' | 'time' | 'large-number' | 'number',
  shouldDisplaySign = false,
  maximumFractionDigits = 1
) {
  if (unit === 'time') return formatMillisecondsToHumanReadable(value, { withMilliseconds: true })

  const formatter = getMetricFormatter({
    unit,
    shouldDisplaySign,
    maximumFractionDigits,
  })

  return formatter.format(value)
}
